import { DatePicker as AntdDatePicker, type DatePickerProps } from 'antd'
import ruLocale from 'antd/es/date-picker/locale/ru_RU'
import classNames from 'classnames'
import dayjs from 'dayjs'

import cn from './AtomDatePicker.module.scss'

const DEFAULT_FORMAT = 'DD.MM.YYYY'

type DatePickerPropsType = Omit<DatePickerProps, 'classNames'> & {
  isOrganisationSelected?: boolean
  allowFutureDates?: boolean
}

function AtomDatePicker({
  isOrganisationSelected = false,
  className,
  allowClear = true,
  format = DEFAULT_FORMAT,
  allowFutureDates = false,
  maxDate,
  ...restProps
}: DatePickerPropsType) {
  return (
    <AntdDatePicker
      {...restProps}
      allowClear={allowClear}
      format={format}
      locale={{
        ...ruLocale,
        lang: {
          ...ruLocale.lang,
          fieldDateFormat: typeof format === 'string' ? format : DEFAULT_FORMAT,
        },
      }}
      maxDate={maxDate ?? (allowFutureDates ? undefined : dayjs().endOf('day'))}
      className={classNames(cn.datePicker, className)}
      classNames={{
        popup: {
          root: classNames(
            cn.datePickerPopup,
            isOrganisationSelected && cn.datePickerPopupSelected
          ),
        },
      }}
    />
  )
}

export default AtomDatePicker
